import React, { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { UserStateComponent } from '../../../components';
import { Permission, Role } from '../../../models';
import { Fetcher, useFetcher, useUserSafe } from '../../../utils';
import { RoleEdit } from './RoleEdit';
import { RoleList } from './RoleList';

interface LoadingData {
  permissions: Permission[];
  roles: Role[];
}

export const RolesPage: FC = () => {
  const { path } = useRouteMatch();
  const user = useUserSafe();

  const fetcher = useFetcher(async (): Promise<LoadingData> => {
    const [permissions, roles] = await Promise.all([api.getPermissions(), api.getRoles()]);
    return { permissions, roles };
  });

  if (!fetcher.data) {
    return <Fetcher result={fetcher} />;
  }

  const { permissions, roles } = fetcher.data;

  return (
    <UserStateComponent>
      <Switch>
        <Route exact path={path}>
          <RoleList roles={roles} user={user} />
        </Route>
        <Route
          path={`${path}/:id`}
          render={(props) => (
            <RoleEdit
              {...props}
              permissions={permissions}
              refresh={fetcher.refresh}
              roles={roles}
              user={user}
            />
          )}
        />
      </Switch>
    </UserStateComponent>
  );
};
